import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const DiscardedEmptyState = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} data-test="blocked-empty-state" {...props}>
    <path
      d="M12.691 64.111a51.199 51.199 0 0 0 87.404 36.204 51.198 51.198 0 0 0-36.204-87.404 51.2 51.2 0 0 0-51.2 51.2Z"
      fill={colors.grey5}
    />
    <path
      d="M97.871 96.522c0-1.408-14.926-2.56-33.338-2.56-18.413 0-33.34 1.146-33.34 2.56 0 1.415 14.927 2.56 33.34 2.56 18.412 0 33.338-1.148 33.338-2.56Z"
      fill={colors.purple10}
    />
    <path
      d="m87.464 24.32 8.92 71.406-7.409-.278-2.288-6.864a2.963 2.963 0 0 0-2.816-2.026H65.926a2.964 2.964 0 0 0-2.816 2.026l-2.288 6.864h-8.886L46.01 24.32h7.408l1.152 9.258a2.964 2.964 0 0 0 2.944 2.596h20.698a2.963 2.963 0 0 0 2.944-3.328l-1.067-8.526h7.375Z"
      fill={colors.mustard20}
    />
    <path
      d="m54.575 33.582-1.157-9.262H46.01l.988 11.854h10.519a2.964 2.964 0 0 1-2.942-2.592Z"
      fill={colors.mustard20}
    />
    <path
      d="m87.464 24.32 8.92 71.406-7.409-.278-2.288-6.864a2.963 2.963 0 0 0-2.816-2.026H65.926a2.964 2.964 0 0 0-2.816 2.026l-2.288 6.864h-8.886L46.01 24.32h7.408l1.152 9.258a2.964 2.964 0 0 0 2.944 2.596h20.698a2.963 2.963 0 0 0 2.944-3.328l-1.067-8.526h7.375Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M87.464 18.396a1.481 1.481 0 0 0-1.481-1.48H44.527a1.481 1.481 0 0 0-1.48 1.48v5.924h44.415l.002-5.924Z"
      fill="#FFF8D9"
    />
    <path
      d="M87.464 18.396a1.481 1.481 0 0 0-1.481-1.48H44.527a1.481 1.481 0 0 0-1.48 1.48v5.924h44.415l.002-5.924Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m77.126 24.32-1.152 9.258a2.964 2.964 0 0 1-2.944 2.596h-20.7a2.963 2.963 0 0 1-2.944-3.328l1.069-8.526h-7.409l-8.89 71.128h7.408l2.289-6.864a2.964 2.964 0 0 1 2.816-2.026h17.95a2.964 2.964 0 0 1 2.815 2.026l2.289 6.864h8.89l5.922-71.128h-7.409Z"
      fill="#FFF8D9"
    />
    <path
      d="m77.126 24.32-1.152 9.258a2.964 2.964 0 0 1-2.944 2.596h-20.7a2.963 2.963 0 0 1-2.944-3.328l1.069-8.526h-7.409l-8.89 71.128h7.408l2.289-6.864a2.964 2.964 0 0 1 2.816-2.026h17.95a2.964 2.964 0 0 1 2.815 2.026l2.289 6.864h8.89l5.922-71.128h-7.409Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.716 47.908a14.164 14.164 0 1 0-.002 28.327 14.164 14.164 0 0 0 .002-28.327Zm0 5.31a8.765 8.765 0 0 1 4.064 1.032L51.896 66.135a8.749 8.749 0 0 1-1.031-4.064 8.852 8.852 0 0 1 8.85-8.852Zm0 17.704a8.756 8.756 0 0 1-4.064-1.031l11.883-11.885a8.75 8.75 0 0 1 1.032 4.065 8.851 8.851 0 0 1-8.851 8.851Z"
      fill={colors.purple10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
